import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function getGroupsAPI() {
  const url = `${AWS_API_URL}/2n/groups`;
  return getRequest(url, await authorize());
}

